import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitProperty = (data) => api.post("/property-submissions", data).then((r) => r.data);
export const submitFinancing = (data) => api.post("/financing-requests", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitWholesale = (data) => api.post("/wholesale-deals", data).then((r) => r.data);
export const submitSeller = (data) => api.post("/seller-leads", data).then((r) => r.data);
export const submitBuyer = (data) => api.post("/buyers", data).then((r) => r.data);
export const submitSection8 = (data) => api.post("/section8-leads", data).then((r) => r.data);

export const getInspectionServices = () => api.get("/inspections/services").then((r) => r.data);
export const getInspectionOptions = () => api.get("/inspections/options").then((r) => r.data);
export const getInspectionQuote = (data) => api.post("/inspections/quote", data).then((r) => r.data);
export const getAvailability = (serviceId, month) =>
  api.get("/inspections/availability", { params: { service_id: serviceId, month } }).then((r) => r.data);
export const createInspectionBooking = (data) => api.post("/inspections/bookings", data).then((r) => r.data);

export const adminApi = axios.create({ baseURL: API, withCredentials: true });
export const getFieldServices = () => adminApi.get("/field-services").then((r) => r.data);
export const getFieldService = (id) => adminApi.get(`/field-services/${id}`).then((r) => r.data);
export const createServiceRequest = (data) => adminApi.post("/service-requests", data).then((r) => r.data);
export const uploadAttachment = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return adminApi.post("/uploads", fd).then((r) => r.data);
};
export const openFile = async (id) => {
  const win = window.open("", "_blank");
  try {
    const r = await adminApi.get(`/files/${id}`, { responseType: "blob" });
    win.location.href = URL.createObjectURL(r.data);
  } catch (e) {
    win.close();
    throw e;
  }
};
adminApi.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status === 401 && !cfg._retried && !cfg.url.startsWith("/auth/")) {
    cfg._retried = true;
    try {
      await adminApi.post("/auth/refresh");
      return adminApi(cfg);
    } catch {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d.msg === "string" ? d.msg : String(d);
}

export const money = (n) =>
  n == null ? "Custom quote" : `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
